import BottomSheet from '../common/BottomSheet';
import { ICON_CATALOG, MAX_TEMPLATE_ICONS } from '../../constants/iconCatalog';

/**
 * Categorized icon picker opened from TemplateEditorSheet's "＋追加"
 * button. Tapping an icon toggles it in/out of the parent's `icons`
 * array (add if not selected and under the 4-icon cap, remove if
 * already selected) — selection order is controlled entirely by the
 * parent (see TemplateEditorSheet), this component only reports taps.
 */
export default function IconPickerSheet({ open, onClose, selectedIcons, onToggle }) {
  const atMax = selectedIcons.length >= MAX_TEMPLATE_ICONS;

  return (
    <BottomSheet
      open={open}
      onClose={onClose}
      title={`アイコンを選択（${selectedIcons.length}/${MAX_TEMPLATE_ICONS}）`}
      footer={
        <button className="btn btn-filled" type="button" onClick={onClose} style={{ flex: 1 }}>
          完了
        </button>
      }
    >
      {ICON_CATALOG.map((group) => (
        <div className="field icon-picker-group" key={group.category}>
          <label>
            {group.categoryIcon} {group.category}
          </label>
          <div className="icon-picker-grid">
            {group.items.map(({ icon, label }) => {
              const selected = selectedIcons.includes(icon);
              const disabled = !selected && atMax;
              return (
                <button
                  type="button"
                  key={icon + label}
                  className={`icon-picker-opt${selected ? ' selected' : ''}`}
                  disabled={disabled}
                  onClick={() => onToggle(icon)}
                >
                  <span className="ipo-emoji">{icon}</span>
                  <span className="ipo-label">{label}</span>
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </BottomSheet>
  );
}
